// Third party
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Hooks
import { WelcomeController } from '../../../services';

// Components
import {
  persistor,
  catalogDataActions,
  profileDataActions,
  shootingDataActions,
  vcatKitsDataActions,
  dashboardDataActions,
  assignmentDataActions,
  managedUsersDataActions,
  accountRootsDataActions,
  billingReportDataActions,
  scenarioUsageDataActions,
  activeSessionsDataActions,
} from '../../../store';
import { queryClient } from '../../../App';

export function useLogoutAPI() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const clearAppState = useCallback(async () => {
    dispatch(shootingDataActions.resetShootingData());
    dispatch(profileDataActions.resetProfileInfo());
    dispatch(dashboardDataActions.resetDashboardData());
    dispatch(catalogDataActions.resetCatalogInfo());
    dispatch(assignmentDataActions.resetCatalogInfo());
    dispatch(accountRootsDataActions.resetAccountRootsInfo());
    dispatch(vcatKitsDataActions.resetVcatKitsData());
    dispatch(billingReportDataActions.resetBillingReport());
    dispatch(scenarioUsageDataActions.resetScenarioUsageData());
    dispatch(activeSessionsDataActions.resetActiveSessionsData());
    dispatch(managedUsersDataActions.resetManagedUsers());
    await persistor.purge();
    queryClient.clear();
  }, [dispatch]);

  const logout = useCallback(async () => {
    try {
      WelcomeController().logout();
      await clearAppState();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  }, [clearAppState, navigate]);

  return { logout, clearAppState };
}
